import { useEffect, useState } from "react";
import { http, galleryFileUrl } from "../lib/api";
import { SAMPLE_GALLERY } from "../content/site";

export function usePrices() {
  const [prices, setPrices] = useState({});
  useEffect(() => {
    http.get("/packages/prices").then((r) => setPrices(r.data && typeof r.data === "object" ? r.data : {})).catch(() => {});
  }, []);
  return (key, fallback) => prices?.[key] ?? fallback;
}

export function useGallery() {
  const [items, setItems] = useState(SAMPLE_GALLERY);
  useEffect(() => {
    Promise.all([http.get("/gallery"), http.get("/settings")])
      .then(([g, s]) => {
        const uploads = (Array.isArray(g.data) ? g.data : []).map((i) => ({ ...i, src: galleryFileUrl(i.id) }));
        const showSamples = s.data?.show_sample_gallery ?? true;
        setItems([...uploads, ...(showSamples || uploads.length === 0 ? SAMPLE_GALLERY : [])]);
      })
      .catch(() => {});
  }, []);
  return items;
}
